import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const UrgencyBar = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 w-full z-50 bg-brand-dark text-brand-light border-b border-brand-accent/30 shadow-lg" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-2 sm:gap-6 text-sm sm:text-base font-medium" data-id="element-144">
        <div className="flex items-center gap-2" data-id="element-145">
          <span className="w-2 h-2 rounded-full bg-brand-accent animate-pulse-slow" data-id="element-146"></span>
          <span className="text-brand-accent font-bold uppercase tracking-wide" data-id="element-147">
            Flash Sale:
          </span>
          <span data-id="element-148">
            90% OFF today only. Secure your career before the price returns to
            $497.
          </span>
        </div>

        <div className="flex items-center gap-4 font-bold bg-brand-accent/10 px-3 py-1 rounded-full border border-brand-accent/20" data-id="element-149">
          <div className="flex items-center gap-1 text-brand-accent" data-id="element-150">
            <span className="w-6 text-center" data-id="element-151">
              {formatTime(timeLeft.hours)}
            </span>
            :
            <span className="w-6 text-center" data-id="element-152">
              {formatTime(timeLeft.minutes)}
            </span>
            :
            <span className="w-6 text-center" data-id="element-153">
              {formatTime(timeLeft.seconds)}
            </span>
          </div>
          <div className="w-px h-4 bg-brand-accent/30" data-id="element-154"></div>
          <div className="text-brand-light" data-id="element-155">
            <span className="text-brand-accent" data-id="element-156">27</span>/100 spots left
          </div>
        </div>
      </div>
    </motion.div>;
};